import { render } from "./CallPlayerBullets.vue?vue&type=template&id=796c72d5&ts=true"
import script from "./CallPlayerBullets.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallPlayerBullets.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallPlayerBullets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "796c72d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('796c72d5', __exports__)) {
    api.reload('796c72d5', __exports__)
  }
  
  module.hot.accept("./CallPlayerBullets.vue?vue&type=template&id=796c72d5&ts=true", () => {
    api.rerender('796c72d5', render)
  })

}


export default __exports__